export default __webpack_public_path__ + "static/media/BTC-BNB.f4825623.png";